module.exports = __webpack_public_path__ + "img/logo-white.851209a2.png";